export enum ImportantDateEventEnum {
    SystemAdministration = 1,
    InstitutionAdministrationInMasterData = 2,
    DataSynchronizationFromMasterData = 3,
    DeliveryOfInitialLists = 4,
    InstitutionAdministration = 5,
    RegularEnrollmentForHandicapped = 6,
    EarlyEnrollmentOrTemporaryExemption = 7,
    RegularEnrollment = 8,
    PsychophysicalExaminationForHandicapped = 9,
    PsychophysicalExamination = 10,
    Decision = 11,
    Appeal = 12,
    DecisionOnAppeal = 13,
    OtherApplications = 14,
    FinalListConfirmation = 15,
    RegistrationSignature = 16,
    EnrollmentSynchronization = 17
}
  